import Select from "components/common/inputs/Select/SelectField";

import gendersText from "utils/gender";

const genderOptions = [...gendersText].map(([code, text], index) => ({
  index,
  name: text,
  value: code,
}));

const GenderSelect = (props) => {
  return <Select defaultValue={gendersText[0]} options={genderOptions} {...props} />;
};

export default GenderSelect;
